export default __webpack_public_path__ + "static/Panasonic-2601c3e98c469fae0f57140931f116bd.jpg";